import { useTranslation } from 'react-i18next';

import { formatMillionsNumber } from '~/modules/artist-roster/utils/formatMillionsNumber';

// @TODO WMG1-827 Replace mock data with real data.
export function BudgetMetrics() {
  const { t } = useTranslation('campaign-planner');

  return (
    <div className="-mr-xl ml-auto grid basis-[760px] grid-cols-4 content-start gap-x-xl gap-y-lg divide-x-px pt-lg">
      <div className="border-l-px pl-xl border-transparent">
        <div className="mb-md text-body-sm font-bold leading-3 text-subtle">
          {t('digitalCampaigns.mediaPlan.budgetDistribution.metrics.markets')}
        </div>
        <div className="text-display-sm leading-none">1</div>
      </div>
      <div className="pl-xl border-emphasis-subtle">
        <div className="mb-md text-body-sm font-bold leading-3 text-subtle">
          {t('digitalCampaigns.mediaPlan.budgetDistribution.metrics.platforms')}
        </div>
        <div className="text-display-sm leading-none">3</div>
      </div>
      <div className="pl-xl border-emphasis-subtle">
        <div className="mb-md text-body-sm font-bold leading-3 text-subtle">
          {t(
            'digitalCampaigns.mediaPlan.budgetDistribution.metrics.impressions',
          )}
        </div>
        <div className="text-display-sm leading-none">
          {formatMillionsNumber(10_500_000, true)}
        </div>
      </div>
      <div className="pl-xl border-emphasis-subtle">
        <div className="mb-md text-body-sm font-bold leading-3 text-subtle">
          {t('digitalCampaigns.mediaPlan.budgetDistribution.metrics.reach')}
        </div>
        <div className="text-display-sm leading-none">
          {formatMillionsNumber(6_000_000, true)}
        </div>
      </div>
      <div className="pl-xl border-transparent">
        <div className="mb-md text-body-sm font-bold leading-3 text-subtle">
          {t(
            'digitalCampaigns.mediaPlan.budgetDistribution.metrics.videoViews',
          )}
        </div>
        <div className="text-display-sm leading-none">
          {formatMillionsNumber(3_200_000, true)}
        </div>
      </div>
      <div className="pl-xl border-emphasis-subtle">
        <div className="mb-md text-body-sm font-bold leading-3 text-subtle">
          {t('digitalCampaigns.mediaPlan.budgetDistribution.metrics.clicks')}
        </div>
        <div className="text-display-sm leading-none">
          {formatMillionsNumber(26_800, true)}
        </div>
      </div>
      <div className="pl-xl border-emphasis-subtle">
        <div className="mb-md text-body-sm font-bold leading-3 text-subtle">
          {t(
            'digitalCampaigns.mediaPlan.budgetDistribution.metrics.engagement',
          )}
        </div>
        <div className="text-display-sm leading-none">
          {formatMillionsNumber(3_400_000, true)}
        </div>
      </div>
      <div className="border-emphasis-subtle" />
    </div>
  );
}

BudgetMetrics.displayName = 'BudgetMetrics';
